<template>
	<div class="vr-iframe-box">
		<iframe class="vr-iframe" frameborder="0" :src="src" @load="loading = false"></iframe>
		<div v-if="loading" v-loading="loading" class="mask" element-loading-text="加载中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"></div>
		<div v-if="!loading" class="back-zq" :class="{mobile:isMobile}" @click="$emit('update:show',false)"><i class="el-icon-arrow-left"></i></div>
	</div>
</template>

<script>
	export default {
		props: {
			src:{
				type:String,
				default:''
			}
		},

		data() {
			return {
				loading: true
			}
		},
	}
</script>

<style scoped>
	.vr-iframe-box {
		position: absolute;
		left: 0;
		top: 0;
		z-index: 10000;
		overflow: hidden;
		width: 100%;
		height: 100%;
		background: #000;
	}


	.vr-iframe {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
	}


	.vr-iframe-box .mask {
		position: absolute;
		width: 80px;
		height: 80px;
		color: #fff;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		overflow: hidden;
		border-radius: 6px;
	}

	.vr-iframe-box .mask ::v-deep .el-icon-loading {
		color: #fff;
	}

	.vr-iframe-box .mask ::v-deep .el-loading-text {
		font-size: 12px;
		color: #fff;
	}

	.back-zq {
		position: absolute;
		top: 12px;
		right: 12px;
		background: #fff;
		cursor: pointer;
		font-weight: bold;
		/*animation: fadeIn 1s ease 3s;*/
		/*animation-fill-mode: forwards;*/
		border-radius: 20px;
		font-size: 13px;
		height: 32px;
		width: 32px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.back-zq.mobile {
		top: 12px;
		right: auto;
		left:12px
	}

	.back-zq i {
		font-weight: bold;
	}

	/*@keyframes fadeIn {*/
	/*	from {*/
	/*		opacity: 0*/
	/*	}*/
	/*	to {*/
	/*		opacity: 1*/
	/*	}*/
	/*}*/

</style>